import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SelectAmountComponent } from "@modules/+new/payments/shared-payments/components/select-amount/select-amount.component";
import { FiatAmountTileComponent } from "@modules/+new/payments/shared-payments/components/fiat-amount-tiles/fiat-amount-tile/fiat-amount-tile.component";
import { FiatAmountTilesComponent } from "@modules/+new/payments/shared-payments/components/fiat-amount-tiles/fiat-amount-tiles.component";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { ModalModule } from "@modules/app-modal/modal.module";
import { BpSwitchModule } from "@modules/core/components/bp-switch/bp-switch.module";
import { FiatPrecisionPipeModule } from "@modules/+new/shared/fiat-precision-pipe/fiat-precision-pipe.module";
import { FiatSymbolPipeModule } from "@modules/+new/shared/fiat-symbol-pipe/fiat-symbol-pipe.module";
import { SummaryGridModule } from "@modules/+new/payments/shared-payments/components/summary-grid/summary-grid.module";
import { SummaryCommonModule } from "@modules/+new/payments/shared-payments/components/summary-common/summary-common.module";
import { SummaryCommonComponent } from "@modules/+new/payments/shared-payments/components/summary-common/summary-common.component";
import { SelectAmountViewDataAdapter } from "@modules/+new/payments/shared-payments/components/select-amount/select-amount.model";
import { VerifyPinComponent } from "./components/verify-pin/verify-pin.component";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { UserVerificationComponent } from "@modules/+new/payments/shared-payments/components/user-verification/user-verification.component";
import { DepositNowModalComponent } from "@modules/trade/modals/deposit-now-modal/deposit-now-modal.component";
import { A11yModule } from "@angular/cdk/a11y";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	declarations: [
		SelectAmountComponent,
		FiatAmountTileComponent,
		FiatAmountTilesComponent,
		VerifyPinComponent,
		UserVerificationComponent,
		DepositNowModalComponent
	],
	imports: [
		CommonModule,
		CoreModule,
		TranslationPipeModule,
		ModalModule,
		SummaryGridModule,
		BpSwitchModule,
		FiatPrecisionPipeModule,
		FiatSymbolPipeModule,
		SummaryCommonModule,
		UniversalModalModule,
		A11yModule
	],
	exports: [SelectAmountComponent, SummaryCommonComponent, VerifyPinComponent],
	providers: [SelectAmountViewDataAdapter]
})
export class SharedPaymentsModule {}
